import React, { useEffect, useState, useContext } from "react";
import eventBus from '../../utils/globalPubSub';

import { getLoginInformation,
         setPaymentDetails,
         setWalletDetails,
         setSocialHandleInformation
} from '../../utils/loginHelper';



import {UserContext} from '../../utils/userDetailsProvider';


import Web2CardManagerComponent from '../BidComponents/Web2CardManager/Web2CardManagerComponent';
import NFTNavDesktop from './NFTNavDesktop';
import NFTNavMobile from './NFTNavMobile';
import WinBidModal from '../BidComponents/WinBidModal'
import AddSocialManagerComponent from '../PerkComponents/AddSocialManagerComponent';

export default function NFTNavx({
    activeTab, setActiveTab,
    userChainId,
    showTabs,
    creator,
    expanded=true,
    ownedTab=true}) {
    
    const [active, setActive] = useState(activeTab);
    const [startsWithAddCard, setStartWithAddCard] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [address, setAddress] = useState('');
    const [accString, setAccString] = useState('')
    const [connected, setIsConnected] = useState(false);
    const [user, setUser] = useState({});
    const [addPaymentModalOpen, setAddPaymentModalOpen] = useState(false);
    const [addSocialModalOpen, setAddSocialModalOpen] = useState(false);
    const [mobileNavModal, setMobileNavModal] = useState(false);
    
    const userDetails = useContext(UserContext);
    const isMobile = userDetails.isMobile;
    
    const handleLogin = async (loginDetails)=>{
        setIsConnected(true);
        setUser(loginDetails.user);        
    }

    const handleLogout = ()=> {
        setIsConnected(false);
        setUser({});
        setShowModal(false)
    }

    
    useEffect(()=>{
        let loginData = getLoginInformation();
        if(loginData){
            handleLogin(loginData);
        }
        eventBus.on("user-logged-in",(data)=>{
            handleLogin(data);
        });
        eventBus.on("user-logged-out",()=>{
            handleLogout();
        })
        return ()=>{
            eventBus.remove("user-logged-in");
            eventBus.remove("user-logged-out");
        }
    },[]);

    useEffect(()=>{
        let loginData = getLoginInformation();
        if(loginData){
            setPaymentDetails();
            setWalletDetails();
            setSocialHandleInformation();
        }
    },[])
    
    const changeTab = (tab) => {
	setActive(tab);
	setActiveTab(tab);
    }

    const openAddPaymentsDiv = ()=>{
        setStartWithAddCard(true)
        setShowModal(false);
        setAddPaymentModalOpen(true);
    }

    const openAddPaymentsDivFromBid = ()=>{
        setStartWithAddCard(false)
        setShowModal(false);
        setAddPaymentModalOpen(true);
    }

    useEffect(()=>{
        eventBus.on('open-payment-information', () =>{
            openAddPaymentsDivFromBid()
        })
        return  ()=>{
            eventBus.remove('open-payment-information')
        }
    },[])
    
    return (
        <>
            {(connected) && (
                <>
                    <Web2CardManagerComponent
                        isOpen={addPaymentModalOpen}
                        startsWithAddCard={startsWithAddCard}
                        handleModalCloseEvent={()=>{
                            setAddPaymentModalOpen(false)}}
                    >
                    </Web2CardManagerComponent>
                    <WinBidModal>
                    </WinBidModal>
                    <AddSocialManagerComponent
                        isOpen={addSocialModalOpen}
                        handleModalCloseEvent={()=>{
                            setAddSocialModalOpen(false)} }
                    >
                    </AddSocialManagerComponent>
                </>)}
            {!isMobile && (
                <NFTNavDesktop
                    connected={connected}
                    user={user}
                    creator={creator}
                    setShowModal={setShowModal}
                    showModal={showModal}
                    openAddPaymentsDiv={openAddPaymentsDiv}
                    setAddSocialModalOpen={setAddSocialModalOpen}
                    address={address}
                    accString={accString}
                    expanded={expanded}
                    showTabs={showTabs}
                    ownedTab={ownedTab}
                    active={active}
                    changeTab={changeTab}
                ></NFTNavDesktop>
            )}
            {isMobile && (
                <NFTNavMobile
                    mobileNavModal={mobileNavModal}
                    setMobileNavModal={setMobileNavModal}
                    connected={connected}
                    user={user}
                    creator={creator}
                    setShowModal={setShowModal}
                    showModal={showModal}
                    openAddPaymentsDiv={openAddPaymentsDiv}
                    setAddSocialModalOpen={setAddSocialModalOpen}
                    address={address}
                    accString={accString}
                ></NFTNavMobile>
            )}
        </>
    );
}
